import {Component, ContentChildren, QueryList} from '@angular/core';
import {AutocompleteInputOptionComponent} from './autocomplete-input-option/autocomplete-input-option.component';

@Component({
    selector: 'vui-autocomplete-input-options',
    templateUrl: './autocomplete-input-options.component.html',
    styleUrls: ['./autocomplete-input-options.component.scss']
})
export class AutocompleteInputOptionsComponent {
    @ContentChildren(AutocompleteInputOptionComponent) public autocompleteInputOptions: QueryList<AutocompleteInputOptionComponent>;

    constructor() {
    }
}
